module.exports = "../../../../platform/assets/pageMainIcon/youth_jichudanganlei3.svg";